import { callPostExternalApi } from '../utils/externalApiCall';

// @ts-ignore
const baseURL = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_BASE_CONTEXT_SII}`;

/**
 * Listado de rutas del backend
 *
 * @return {Object.<string,string>}
 */
const getBackendUrl = () => ({
  POST_CERTIFICATE: `${baseURL}/access/certificate`,
});

/**
 * @returns {Promise<*>}
 */
const postCertificate = async () => callPostExternalApi({ url: getBackendUrl().POST_CERTIFICATE });

export default postCertificate;
